import { ref, computed, watch } from 'vue'

export function usePagination(filteredItems, pageSize = 40, resetSources = filteredItems) {
  const currentPage = ref(1)

  const totalPages = computed(() =>
    Math.ceil(filteredItems.value.length / pageSize) || 1
  )

  const paginatedItems = computed(() => {
    const start = (currentPage.value - 1) * pageSize
    return filteredItems.value.slice(start, start + pageSize)
  })

  function resetPage() {
    currentPage.value = 1
  }

  watch(resetSources, resetPage, { flush: 'sync' })
  watch([currentPage, totalPages], () => {
    currentPage.value = Math.max(1, Math.min(totalPages.value, currentPage.value))
  }, { flush: 'sync' })

  return { currentPage, totalPages, paginatedItems, resetPage }
}
